import { styled } from '@precis-digital/kurama/utils'
import { type CSSObject } from '@precis-digital/kurama/theme'
import Typography from '@precis-digital/kurama/Typography'

export const StyledContainer = styled('div')<{ $gap: string; $padding: string }>(
  ({ theme, $gap: gap, $padding: padding }): CSSObject => ({
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    gap,
    padding,
    borderRadius: theme.borderRadius.xxLarge
  })
)

export const StyledImageWrapper = styled('div')<{ width: number; height: number }>(
  ({ width, height }): CSSObject => ({
    flexShrink: 0,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width,
    height,
    maxWidth: '100%',
    overflow: 'hidden',
    '& img': {
      width: '100%',
      height: '100%',
      objectFit: 'contain'
    }
  })
)

export const StyledButtonGroup = styled('div')(
  ({ theme }): CSSObject => ({
    display: 'flex',
    gap: theme.spacing(1),
    justifyContent: 'center',
    flexWrap: 'wrap',
    maxWidth: '100%'
  })
)

export const StyledTextGroup = styled('div')(
  ({ theme }): CSSObject => ({
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: theme.spacing(2),
    textAlign: 'center'
  })
)

export const StyledDescription = styled(Typography)<{ $textMaxWidth: number }>(
  ({ $textMaxWidth: textMaxWidth }): CSSObject => ({
    maxWidth: textMaxWidth,
    textAlign: 'center'
  })
)
